// extracted by mini-css-extract-plugin
export default {"root":"BankTransactionDetailAnalysisConclusionList_root__dnWtv","subheadingItem":"BankTransactionDetailAnalysisConclusionList_subheadingItem__rF46C"};